import {inject} from '@angular/core';
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, map, mergeMap} from "rxjs/operators";
import {of} from "rxjs";
import {ExportRequestsChildrenActions} from "./export-requests-children.actions";
import {ExportRequestMapper} from '../../../mappers/table/export-requests/export-request-mapper';
import {ExportResquestRepo} from "../../../repositories/private";

export class ExportRequestChildrenEffect {
  private actions$ = inject(Actions);
  private exportRequestMapper = inject(ExportRequestMapper);
  private exportRequestRepo = inject(ExportResquestRepo);

  searchExportRequests$ = createEffect(() => {
    let parentId: string;

    return this.actions$.pipe(
      ofType(ExportRequestsChildrenActions.search),
      mergeMap((param) => {
        parentId = param.filter.uid;
        return this.exportRequestRepo
          .searchExportRequestChirdren(param.filter)
          .pipe(
            map((response: any) => ({
              paging: response.paging,
              list: this.exportRequestMapper.mapEntities(response.list ?? []),
              parentId: parentId,
            })),
            map((response: any) =>
              ExportRequestsChildrenActions.fetchSuccess({ response })
            ),
            catchError((error) =>
              of(
                ExportRequestsChildrenActions.fetchFailure({
                  message: error?.toString(),
                  parentId: parentId,
                })
              )
            )
          );
      })
    );
  });
}
